"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Bar = require("./Bar");

var _Arrow = require("./Arrow");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LineStyled = _styledComponents["default"].div.withConfig({
  displayName: "Line__LineStyled",
  componentId: "ph852o-0"
})(["display:flex;width:100%;"]);

var LayerItem = _styledComponents["default"].div.withConfig({
  displayName: "Line__LayerItem",
  componentId: "ph852o-1"
})(["position:absolute;height:fit-content;z-index:1;&:hover{z-index:29 !important;}"]); // export const Line = props => {
//   const theRef = useRef()
//   useEffect(() => console.log('theref', theRef?.current?.firstChild.style))
//   return (
//     <LineStyled {...props}>
//       {props.layerItems.map((l, index) => (
//         <LayerItem
//           ref={theRef}
//           id={`${index}-indice`}
//           key={index}
//           style={{ left: l.position, width: l.width }}
//         >
//           {l.item}
//         </LayerItem>
//       ))}
//       {props.timeLine.map(item =>
//         item.available ? (
//           <Bar key={item.id} {...item} {...props} />
//         ) : (
//           <Arrow key={item.id} {...item} {...props} />
//         )
//       )}
//     </LineStyled>
//   )
// }


var Line = /*#__PURE__*/function (_React$Component) {
  _inherits(Line, _React$Component);

  var _super = _createSuper(Line);

  function Line() {
    var _this;

    _classCallCheck(this, Line);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      layerHeight: 0,
      setOnTop: false
    });

    _defineProperty(_assertThisInitialized(_this), "theRef", void 0);

    return _this;
  }

  _createClass(Line, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.theRef && this.theRef.offsetHeight) {
        this.setState({
          layerHeight: this.theRef.offsetHeight + 15 * this.props.layerItems.length
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      return /*#__PURE__*/React.createElement(LineStyled, _extends({}, props, {
        style: {
          height: this.state.layerHeight,
          minHeight: '38px'
        }
      }), props.layerItems.map(function (l, index) {
        return /*#__PURE__*/React.createElement(LayerItem, {
          ref: function ref(el) {
            _this2.theRef = el;
          },
          id: "".concat(index, "-indice"),
          key: index,
          style: {
            left: l.position,
            width: l.width,
            zIndex: _this2.state.setOnTop ? 2 : 1,
            position: "absolute",
            top: ''.concat((l.index || 0) * 15, 'px')
          }
        },
        /*#__PURE__*/
        // l.item
        React.cloneElement(l.item, {
          // test: '',
          setMeOnTop: function setMeOnTop(e) {
            // console.log('settingOnTop', e)
            _this2.props.onHover && _this2.props.onHover(e);

            _this2.setState({
              setOnTop: e
            });
          }
        }));
      }), props.availability && /*#__PURE__*/React.createElement(LayerItem, {
        style: {
          left: props.availability.position,
          top: "0px"
        },
        onClick: props.availability.onClick || function () {}
      }, props.availability.item), props.manualAvailability && /*#__PURE__*/React.createElement(LayerItem, {
        style: {
          left: props.manualAvailability.position,
          top: "0px"
        },
        onClick: props.manualAvailability.onClick || function () {}
      }, props.manualAvailability.item), props.timeLine.map(function (item, i) {
        return item.available ? /*#__PURE__*/React.createElement(_Bar.Bar, _extends({
          key: item.id
        }, item, props)) : /*#__PURE__*/React.createElement(_Arrow.Arrow, _extends({
          key: item.id,
          index: i
        }, item, props));
      }));
    }
  }]);

  return Line;
}(React.Component);

var _default = Line;
exports["default"] = _default;
Line.propTypes = {
  timeLine: _propTypes["default"].array,
  layerItems: _propTypes["default"].array
};
Line.defaultProps = {
  timeLine: [],
  layerItems: []
};